import dayjs from 'dayjs';

export function separeJours(start: Date, end: Date, object: any) {
  const days = []
  for(let d = dayjs(start); d.isBefore(end); d = d.add(1, 'day')){
    let dayStart = d.startOf('day').toDate()
    let dayEnd = d.endOf('day').toDate()
    if(d.isSame(start, 'day')){
      dayStart = start
    }
    if(d.isSame(end, 'day')){
      dayEnd = end
    }
    days.push({...object, start: dayStart, end: dayEnd})
  }
  return days;
}

export function calculOpacite(couleur: string, opacite: number = 1){
  return `${couleur}${Math.round(opacite * 255).toString(16).padStart(2, '0').toUpperCase()}`;
}

export function ecritureContrastee(codeHexa: string){
  let hexa = codeHexa;
  if(codeHexa[0] === '#'){
    hexa = codeHexa.substring(1);
  }

  const r = parseInt(hexa.substring(0, 2), 16);
  const g = parseInt(hexa.substring(2, 4), 16);
  const b = parseInt(hexa.substring(4, 6), 16);

  // Formule de luminance perçue (YIQ)
  const yiq = (r * 299 + g * 587 + b * 114) / 1000;

  // Si la couleur est sombre → texte blanc, sinon noir
  return yiq >= 128 ? 'black' : 'white';
}

export function capitalize(s: string){
  return s.charAt(0)?.toUpperCase() + s.slice(1)
}

export function camelCaseToPhrase(s: string) {
  return s.replaceAll(/[A-Z]/g, ' $&' ).trim();
}

export const IconMapper = {
  1: "palm-tree",          // Congés
  2: "briefcase-clock-outline",      // RTT
  3: "emoticon-sick",      // Maladie
  4: "clock-plus-outline",              // Heures Supplémentaires
  5: "piggy-bank",         // Compte-épargne Temps
  6: "school",             // Formation
  7: "stethoscope",        // Visite médicale
  8: "clipboard-check",    // Quotas
  9: "baby-carriage",      // Maternité
  10: "bandage",           // Accident du travail
  11: "folder",            // Divers
};

export async function downloadFile(file: Blob, filename: string, _route: string): Promise<string | void> {
  // Web: téléchargement via le navigateur
  const url = window.URL.createObjectURL(file);
  const link = document.createElement('a');
  link.href = url;
  link.setAttribute('download', filename);
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  window.URL.revokeObjectURL(url);
  return filename;
}

export function getMimeTypeFromExtension(extension = "txt") {
    if (extension[0] === ".") {
        extension = extension.substring(1);
    }
    return {
        "aac": "audio/aac",
        "abw": "application/x-abiword",
        "arc": "application/x-freearc",
        "avi": "video/x-msvideo",
        "azw": "application/vnd.amazon.ebook",
        "bin": "application/octet-stream",
        "bmp": "image/bmp",
        "bz": "application/x-bzip",
        "bz2": "application/x-bzip2",
        "cda": "application/x-cdf",
        "csh": "application/x-csh",
        "css": "text/css",
        "csv": "text/csv",
        "doc": "application/msword",
        "docx": "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
        "eot": "application/vnd.ms-fontobject",
        "epub": "application/epub+zip",
        "gz": "application/gzip",
        "gif": "image/gif",
        "htm": "text/html",
        "html": "text/html",
        "ico": "image/vnd.microsoft.icon",
        "ics": "text/calendar",
        "jar": "application/java-archive",
        "jpeg": "image/jpeg",
        "jpg": "image/jpeg",
        "js": "text/javascript",
        "json": "application/json",
        "jsonld": "application/ld+json",
        "mid": "audio/midi audio/x-midi",
        "midi": "audio/midi audio/x-midi",
        "mjs": "text/javascript",
        "mp3": "audio/mpeg",
        "mp4": "video/mp4",
        "mpeg": "video/mpeg",
        "mpkg": "application/vnd.apple.installer+xml",
        "odp": "application/vnd.oasis.opendocument.presentation",
        "ods": "application/vnd.oasis.opendocument.spreadsheet",
        "odt": "application/vnd.oasis.opendocument.text",
        "oga": "audio/ogg",
        "ogv": "video/ogg",
        "ogx": "application/ogg",
        "opus": "audio/opus",
        "otf": "font/otf",
        "png": "image/png",
        "pdf": "application/pdf",
        "php": "application/x-httpd-php",
        "ppt": "application/vnd.ms-powerpoint",
        "pptx": "application/vnd.openxmlformats-officedocument.presentationml.presentation",
        "rar": "application/vnd.rar",
        "rtf": "application/rtf",
        "sh": "application/x-sh",
        "svg": "image/svg+xml",
        "swf": "application/x-shockwave-flash",
        "tar": "application/x-tar",
        "tif": "image/tiff",
        "tiff": "image/tiff",
        "ts": "video/mp2t",
        "ttf": "font/ttf",
        "txt": "text/plain",
        "vsd": "application/vnd.visio",
        "wav": "audio/wav",
        "weba": "audio/webm",
        "webm": "video/webm",
        "webp": "image/webp",
        "woff": "font/woff",
        "woff2": "font/woff2",
        "xhtml": "application/xhtml+xml",
        "xls": "application/vnd.ms-excel",
        "xlsx": "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
        "xml": "application/xml",
        "xul": "application/vnd.mozilla.xul+xml",
        "zip": "application/zip",
        "3gp": "video/3gpp",
        "3g2": "video/3gpp2",
        "7z": "application/x-7z-compressed"
    }[extension] || "application/octet-stream";
}

export function getInitials(name?: string) {
  if (!name) return '';
  return name
    .trim()
    .split(' ')
    .filter(Boolean)
    .slice(0, 2)
    .map(part => part[0]?.toUpperCase())
    .join('');
};
